import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Text,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';

import ContentSearch from '@/client/components/admin/shared/search/ContentSearch';
import { CourseFormData } from '@/client/routes/admin/create/content/tracks/EditCourse';
import { useContentSearch } from '@/client/components/admin/shared/search/useContentSearch';
import { useCreateStore } from '@/client/services/state/admin/create/createStore';
import { useDebounceValue } from 'usehooks-ts';
import { useFormContext } from 'react-hook-form';

export default function ContentSearchDrawer() {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { contentTypeOptions } = useContentSearch();
  const [searchTerm, setSearchTerm] = useDebounceValue('', 300);
  const [selectedContentType, setSelectedContentType] = useState<{
    name: string;
    value: string | null;
  } | null>(contentTypeOptions[0]);
  const { instructorDrawerIsOpen, setInstructorDrawerIsOpen, selectedSectionIndex } =
    useCreateStore();

  useEffect(() => {
    if (searchTerm === '') {
      setSelectedContentType(contentTypeOptions[0]);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (!instructorDrawerIsOpen) {
      setSelectedContentType(contentTypeOptions[0]);
      setSearchTerm('');
    }
  }, [instructorDrawerIsOpen]);

  const { watch, setValue } = useFormContext<CourseFormData>();

  const sections = watch('sections');

  const handleItemClick = (item: any, isSelected: boolean | undefined) => {
    const section = sections?.[selectedSectionIndex] ?? { courses: [] };

    if (isSelected) {
      section.courses = section.courses?.filter((course: any) => course.id !== item.id) || [];
      // @ts-ignore
      setValue('sections', sections);
      return;
    }

    (section.courses || []).push(item);

    setValue('sections', sections);
  };

  const handleCheckItemIsSelected = (item: any) =>
    sections?.[selectedSectionIndex]?.courses?.some((course: any) => course.id === item.id) ||
    false;

  return (
    <Drawer
      isOpen={instructorDrawerIsOpen}
      placement="right"
      size="md"
      onClose={() => setInstructorDrawerIsOpen(false)}
      initialFocusRef={inputRef}
    >
      <DrawerOverlay />

      <DrawerContent margin={6} borderRadius="16px">
        <DrawerCloseButton />

        <DrawerBody paddingTop={10}>
          <Text fontSize="24px" fontWeight={600}>
            Add Existing Content
          </Text>

          <ContentSearch
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            selectedContentType={selectedContentType}
            setSelectedContentType={setSelectedContentType}
            handleItemClick={handleItemClick}
            checkItemIsSelected={handleCheckItemIsSelected}
            initialInputRef={inputRef}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
